import { getPositionSuffix, isLeaderboardUpcoming } from 'fitbeat.gym-core';
import { IUserLeaderboardViewModel } from 'fitbeat.models';
import React, { FunctionComponent } from 'react';
import { StyleSheet, Text, View } from 'react-native';
import { TranslateProp } from '../../../common-types';
import Theme from '../../../theme';
import { defaultScale, scaleText } from '../../../utils';

interface IProps {
  leaderboard: IUserLeaderboardViewModel;
  teamPosition?: boolean;
  t: TranslateProp;
}

const LeaderboardOverviewPosition: FunctionComponent<IProps> = (
  {
    leaderboard,
    teamPosition = false,
    t,
  },
) => {
  const positionSubText = () => {
    if (teamPosition) {
      return t('tracking:position');
    }
    return leaderboard.competitionType === 'individual'
      ? t('tracking:position')
      : t('tracking:teamPosition');
  };

  const positionText = () => {
    const myRanking = leaderboard.rankings.find((ranking) => ranking.isMine);
    const isUpcoming = isLeaderboardUpcoming(leaderboard.startDate);
    if (myRanking && !isUpcoming) {
      return (
        <View style={styles.textContainer}>
          <Text style={styles.weightText}>
            {myRanking.rank}
          </Text>
          <Text style={styles.superScriptMuted}>
            {getPositionSuffix(myRanking.rank)}
          </Text>
        </View>
      );
    }

    return (
      <View style={styles.textContainer}>
        <Text style={[styles.lightText, { fontSize: defaultScale(24) }]}>
          -
        </Text>
      </View>
    );
  };

  return (
    <View>
      <View>
        {positionText()}
      </View>
      <Text style={styles.subText}>
        {positionSubText()}
      </Text>
    </View>
  );
};

const styles = StyleSheet.create({
  weightText: {
    fontFamily: Theme.Weight700,
    fontSize: scaleText(24),
    color: Theme.BLACK,
  },
  lightText: {
    display: 'flex',
    fontFamily: Theme.Weight500,
    fontSize: scaleText(16),
    color: Theme.GREY,
    alignSelf: 'flex-end',
    paddingBottom: defaultScale(2),
  },
  textContainer: {
    flexDirection: 'row',
    alignItems: 'flex-end',
  },
  subText: {
    ...Theme.textStyle.small,
    marginTop: defaultScale(2),
  },
  superScriptMuted: {
    ...Theme.textStyle.bodyCopyReg,
    color: Theme.GREY,
    fontFamily: Theme.Weight500,
    alignSelf: 'flex-start',
    marginLeft: defaultScale(2),
  },
});

export default LeaderboardOverviewPosition;
